import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogStopSlotChargingView.propTypes = {
  slotRow: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogStopSlotChargingView({ slotRow = {}, onCancel, onDone }) {
  const [loading, setLoading] = useState(false);

  const slotCode =
    slotRow?.slotCode ??
    (slotRow?.slotNumber != null ? `Ngăn số ${slotRow.slotNumber}` : slotRow?.slotId ?? '');
  const iconSrc = AppResource.vng?.vngTurnOff;

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // TODO: gọi API ngắt sạc ngăn pin với cabinetId/slotId khi có API
      ToastHelper.showSuccess('Ngắt sạc ngăn pin thành công');
      if (onDone) onDone();
    } catch (error) {
      ToastHelper.showError(error?.message || 'Ngắt sạc ngăn pin thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 gap-3">
        <div className="">{iconSrc && <img src={iconSrc} alt="" />}</div>
        <span style={UIHelper.buildFontStyle('600', '16px', undefined, AppColors.gray[800])}>
          Ngắt sạc
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', undefined, AppColors.gray[600])}>
          Bạn có chắc muốn ngắt sạc ngăn pin <strong>{slotCode}</strong> không?
        </span>
      </div>

      <div
        className="d-flex align-items-center gap-3 p-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        <div className="w-50">
          {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        </div>
        <div className="w-50">
          {UIHelper.buildRedButton('Ngắt sạc', handleSubmit, null, false, loading)}
        </div>
      </div>
    </div>
  );
}

export default DialogStopSlotChargingView;

